<template>
  <vs-sidebar click-not-close position-right parent="body"  default-index="1" color="primary" :hidden-background="true" class="add-new-data-sidebar items-no-padding cstm-add-data-sidebar" spacer v-model="addActivitiesMeetingFrom">

    <div class="mt-6 flex items-center justify-between px-6">
      <h4 class="heading-holder">{{ this.header }}</h4>
      <feather-icon icon="XIcon" @click="isAddActivitiesMeetingFormActive = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>


      <div class="p-6 pr-0">
        <form class="mb-4" data-vv-scope="Add_Appointment">
          <div class="form-holder">        
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12">
                <div class="vx-row w-full">
                  <div class="vx-col w-full mb-4">
                    <vs-input v-validate="'required'" placeholder="Enter title" class="w-full" label="Title" data-vv-name="title" v-model="title"/>
                    <div v-if="errors.has('Add_Appointment.title')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.title') }}</div>
                  </div>
                  <div class="vx-col w-full mb-2">
                    <label class="text-xs">Description</label>
                    <vs-textarea v-validate="'required'" data-vv-name="description" placeholder="Start typing the details about the appointment...." v-model="description" />
                    <div v-if="errors.has('Add_Appointment.description')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.description') }}</div>
                  </div>
                  <div class="vx-col flex justify-between w-full mb-4">
                    <label>All day</label>
                    <vs-switch v-model="switch1" />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-4">
                    <!-- <vs-input v-validate="'required'" data-vv-name="checkin date" class="w-full" icon-pack="feather" icon="icon-calendar" icon-after label="From" placeholder="MM/DD/YY" v-model="checkindate" /> -->
                    <flat-pickr v-validate="'required'" icon-pack="feather" icon="icon-calendar" data-vv-name="startDate" icon-after v-model="startDate" :config="{ dateFormat: 'Y-m-d', minDate: 'today' }" label="Date" class="w-full" placeholder="From" />
                    <div v-if="errors.has('Add_Appointment.checkin date')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.checkin date') }}</div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-4">
                    <!-- <vs-input v-validate="'required'" data-vv-name="checkin time" class="w-full" icon-pack="feather" icon="icon-clock" icon-after label="Time" placeholder="HH/MM" v-model="checkintime" /> -->
                    <flat-pickr v-validate="'required'" :config="configdateTimePicker" label="Time" data-vv-name="startTime" v-model="startTime" placeholder="Time" class="w-full" />
                    <div v-if="errors.has('Add_Appointment.startTime')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.startTime') }}</div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-4">
                    <!-- <vs-input v-validate="'required'" data-vv-name="checkout date" class="w-full" icon-pack="feather" icon="icon-calendar" icon-after label="To" placeholder="MM/DD/YY" v-model="checkoutdate" /> -->
                    <flat-pickr  icon-pack="feather" icon="icon-calendar" data-vv-name="endDate" icon-after v-model="endDate" :config="{ dateFormat: 'Y-m-d', minDate: 'today' }" placeholder="To" class="w-full" />
                    <div v-if="errors.has('Add_Appointment.endDate')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.endDate') }}</div>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-4">
                    <!-- <vs-input v-validate="'required'" data-vv-name="checkout time" class="w-full" icon-pack="feather" icon="icon-clock" icon-after label="Time" placeholder="HH/MM" v-model="checkouttime" /> -->
                    <flat-pickr :config="configdateTimePicker" label="Time" class="w-full" data-vv-name="endTime" v-model="endTime" placeholder="Time" />
                    <div v-if="errors.has('Add_Appointment.endTime')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.endTime') }}</div>
                  </div>
                  <div class="vx-col w-full mb-4">
                    <label class="text-sm">Time Zone</label>
                    <vs-select v-validate="'required'" data-vv-name="timezone" v-model="timezone" autocomplete class="w-full select-large">
                      <vs-select-item :key="index" :value="item.timezone_id" :text="item.timezone" v-for="(item,index) in timezones" class="w-full" />
                    </vs-select>
                    <div v-if="errors.has('Add_Appointment.timezone')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.timezone') }}</div>
                  </div>
                  <div class="vx-col w-full mb-4">
                    <vs-input v-validate="'required'" data-vv-name="location" class="w-full" label="Appointment Location" v-model="location"/>
                    <div v-if="errors.has('Add_Appointment.location')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.location') }}</div>
                  </div>
                  <div class="vx-col w-full mb-4">
                    <label class="text-sm">Outcome</label>
                    <vs-textarea v-validate="'required'" data-vv-name="outcome" placeholder="Start typing the details about the outcome...." v-model="outcome" />
                    <div v-if="errors.has('Add_Appointment.outcome')"  style="color:red;" class="invalid-feedback">{{ errors.first('Add_Appointment.outcome') }}</div>
                    </vs-select>
                  </div>
                </div>
              </vs-col>
              <vs-col vs-lg="12" vs-sm="12">
                
                  <div class="mb-4">
                    <label class="text-sm">Related to</label>
                    <!-- <v-select v-validate="'required'" taggable push-tags v-model="relatedToId" multiple autocomplete :options="relatedToIdList" label="first_name" :reduce="relatedToId => relatedToId.users_id" /> -->
                    <vs-select v-validate="'required'" data-vv-name="relatedToId" v-model="relatedToId" autocomplete class="w-full select-large" multiple>
                      <vs-select-item :key="index" :value="item.users_id" :text="item.first_name" v-for="(item,index) in relatedToIdList" class="w-full" />
                    </vs-select>
                  </div>
                  <div class="mb-4">
                    <label class="text-sm">Attendees</label>
                    <!-- <v-select v-validate="'required'" v-model="attendees" multiple autocomplete :options="attendOptions" label="first_name" :reduce="attendees => attendees.users_id" /> -->
                    <vs-select v-validate="'required'" data-vv-name="attendees" v-model="attendees" autocomplete class="w-full select-large" multiple>
                      <vs-select-item :key="index" :value="item.users_id" :text="item.first_name" v-for="(item,index) in attendOptions" class="w-full" />
                    </vs-select>
                  </div>
                
              </vs-col>
            </vs-row>
          </div>

          <div class="footer-sidebar" slot="footer">
            <!-- Save & Cancel Button -->
            <div class="flex flex-wrap items-center justify-end"> 
              <vs-button class="ml-auto mt-2" type="border" color="danger" @click="isAddActivitiesMeetingFormActive = false">Cancel</vs-button>
              <vs-button class="ml-4 mt-2" @click.prevent="saveForm">Save</vs-button>
            </div>
          </div>
        </form>    
      </div>
    </component>
  </vs-sidebar>
</template>

<script>
import { createActivitiesMeeting, editActivitesMeeting } from '@/api/activitiesmeeting'
import { fetchTimeZoneList, getUserList } from '@/api/generalapi'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'


export default {

  components: {
    flatPickr,
    vSelect
  },

  data () {
    return {
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        time_24hr: true
        //maxDate: "today"
        // dateFormat: 'H:i:s'
      },
      addActivitiesMeetingFrom : false,
      header: 'Add Appointment',
      addSideBar:false,
      title: '',
      description: '',
      startDate: '',
      endDate: '',
      endTime : '',
      startTime :'',
      switch1: false,
      outcome: '',
      timezone: '',
      timezones: [],
      location: '',
      attendees : [],
      relatedToId  : [],
      fetchRelatedToId : [],
      fetchAttendessToId : [],
      relatedToIdList: [],
      attend: '',
      attendOptions: [],
      saveStatus: true,
      apiRequestParameter: {},
      activitesMeetingId : ''
    }
  },
  props : {
    leadId: {
      type: Number,
      required: true
    },
    singleActivitesMeetingDetails: {
      type: Object,
      default: () => {}
    }
  },

  mounted ()  {
    this.fetchPlatformTimeZone()
    this.fetchUserList()
  },

  methods: {

    async fetchPlatformTimeZone () {
      const apiResponse = await fetchTimeZoneList()
      this.timezones.push(...apiResponse.data.data.list)
    }, 
    async fetchUserList () {
      const data = await getUserList(this.$store.getters.customerId)
      this.attendOptions.push(...data.data.data.list)
      this.relatedToIdList.push(...data.data.data.list)
    },

    openAnotherSidebar () {

    },
    saveForm () {
      this.$validator.validateAll('Add_Appointment').then(result => {
        const parseStartDate = Date.parse(this.startDate)
        const parseEndDate = Date.parse(this.endDate)
        if (parseStartDate > parseEndDate) {
          this.$vs.notify({
            title: 'Error',
            text: 'Invalid date formation!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } else if (result) {
          if (this.activitesMeetingId === '') {
            if (this.switch1 === false) {
              this.apiRequestParameter = {
                'appointment_title'           :   this.title,
                'appointment_description'     :   this.description,
                'start_datetime'              :   `${this.startDate  } ${  this.startTime}`,
                'end_datetime'                :   `${this.endDate  } ${  this.endTime}`,
                'platform_timezone_id'        :   this.timezone,
                'outcome'                     :   this.outcome,
                'related_to_id'               :   this.relatedToId,
                'attendees'                   :   this.attendees,
                'type'                        :   'CRM',
                'item_id'                     :   this.leadId,
                'location'                    :   this.location,
                'customer_id'                 :   this.$store.getters.customerId
              }
            } else {
              this.apiRequestParameter = {
                'appointment_title'       :   this.title,
                'appointment_description' :   this.description,
                'start_datetime'          :   `${this.startDate  } ${  this.startTime}`,
                'platform_timezone_id'    :   this.timezone,
                'outcome'                 :   this.outcome,
                'related_to_id'           :   this.relatedToId,
                'attendees'               :   this.attendees,
                'type'                    :   'CRM',
                'item_id'                 :   this.leadId,
                'location'                :   this.location,
                'customer_id'             :   this.$store.getters.customerId
              }
            }
            createActivitiesMeeting(this.apiRequestParameter).then(response => {
              this.$vs.notify({
                title: 'Success',
                text: 'Activities Meeting created successfully.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
              this.title = ''
              this.description = ''
              this.startDate = ''
              this.startTime = ''
              this.timezone = ''
              this.outcome = ''
              this.relatedToId = []
              this.attendees = []
              this.location = ''
              this.endDate = ''
              this.endTime = ''
              this.$validator.reset()
            }).catch(apiError => {
              if (apiError.status == 422) {
                this.$vs.notify({
                  title: 'Error',
                  text: 'Error occured.',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'error'
                })
              }
            })
          } else {
            if (this.switch1 === false) {
              this.apiRequestParameter = {
                'activities_meeting_id' : this.activitesMeetingId,
                'appointment_title' : this.title,
                'appointment_description' : this.description,
                'start_datetime' : `${this.startDate  } ${  this.startTime}`,
                'end_datetime' : `${this.endDate  } ${  this.endTime}`,
                'platform_timezone_id' : this.timezone,
                'outcome' : this.outcome,
                'related_to_id' : this.relatedToId,
                'attendees' : this.attendees,
                'location' : this.location
              }
            } else {
              this.apiRequestParameter = {
                'activities_meeting_id' : this.activitesMeetingId,
                'appointment_title' : this.title,
                'appointment_description' : this.description,
                'start_datetime' : `${this.startDate  } ${  this.startTime}`,
                'platform_timezone_id' : this.timezone,
                'outcome' : this.outcome,
                'related_to_id' : this.relatedToId,
                'attendees' : this.attendees,
                'location' : this.location
              }
            }
            editActivitesMeeting(this.apiRequestParameter).then(response => {
              this.$vs.notify({
                title: 'Success',
                text: 'Activities Meeting updated successfully.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
            }).catch(apiError => {
              if (apiError.status === 422) {
                this.$vs.notify({
                  title: 'Error',
                  text: 'Error occured.',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'error'
                })
              }
            })
          }
        } else {
              
        }
      })
    }, 
    addActivitiesMeeting () {
      this.isSidebarActiveLocal = 'openAddActivitiesMeeting'
    }
  },
  watch: {
    'singleActivitesMeetingDetails' () {
      if (Object.keys(this.singleActivitesMeetingDetails).length  === 0) {
        this.header = 'Add Appointment'
        this.title = ''
        this.description = ''
        this.startDate =  ''
        this.endDate =  ''
        this.endTime = ''
        this.startTime = ''
        this.switch1 = false
        this.outcome = ''
        this.timezone = ''
        this.location =  ''
        this.attendees =  []
        this.relatedToId =  []
        this.activitesMeetingId = ''
        this.$validator.reset()
      } else {
        this.header = 'Edit Appointment'
        this.activitesMeetingId = this.singleActivitesMeetingDetails.activities_meeting_id
        this.title = this.singleActivitesMeetingDetails.appointment_title ? this.singleActivitesMeetingDetails.appointment_title : ''
        this.description = this.singleActivitesMeetingDetails.appointment_description ? this.singleActivitesMeetingDetails.appointment_description : ''
        this.location = this.singleActivitesMeetingDetails.location ? this.singleActivitesMeetingDetails.location : ''
        this.outcome = this.singleActivitesMeetingDetails.outcome ? this.singleActivitesMeetingDetails.outcome :  ''
        this.timezone = this.singleActivitesMeetingDetails.platform_timezone_id ? this.singleActivitesMeetingDetails.platform_timezone_id : ''
        this.relatedToId = this.singleActivitesMeetingDetails.related_to_id ? this.singleActivitesMeetingDetails.related_to_id : []
        this.attendees = this.singleActivitesMeetingDetails.attendees ? this.singleActivitesMeetingDetails.attendees : []
        if (this.singleActivitesMeetingDetails.end_datetime === '') {
          this.switch1 = true
        } else {
          this.switch1 = false
          const endDateTimeformat = this.singleActivitesMeetingDetails.end_datetime.split(' ')
          this.endDate = endDateTimeformat[0]
          this.endTime = endDateTimeformat[1]
        }
        const startDateTimeformat = this.singleActivitesMeetingDetails.start_datetime.split(' ')
        this.startDate = startDateTimeformat[0]
        this.startTime = startDateTimeformat[1]
      }
    }
  },

  computed: {
    isAddActivitiesMeetingFormActive: {
      get () {
        return true
      },
      set (value) {
        this.$emit('closeAddActivitiesMeeting', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vs-component .vs-dropdown--item, .vs-dropdown--item-link, .vs-dropdown--group-label, .vs-component .vs-dropdown--group .marginIcon {
    font-weight: 500 !important;
  }
  .vs-sidebar-position-right {
    width: 800px !important;
    max-width: 800px !important;
    z-index: 111111111111111 !important;
    /*height: auto !important;*/
    /*position: absolute;*/
    /*top: 12%;*/
  }
  // [dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items{
  //   overflow-y: scroll;
  // }
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 600px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}

.cstm-add-data-sidebar .vs-sidebar--items form {
    overflow-y: auto;
    height: calc(100vh - 195px);
}
</style>
